import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Button, Spin } from 'antd';
import * as yup from 'yup';
import Translate from 'react-translate-component';

import Input from 'components/common/form/Input';
import RadioButtons from 'components/common/form/RadioButtons';
import withFormWrapper from 'components/hocs/withFormWrapper';
import { DefinitionField } from 'components/common/fields/DefinitionField';

const options = [
    {
        id: true,
        name: <Translate content="common.yes" />
    },
    {
        id: false,
        name: <Translate content="common.no" />
    }
];

const validationSchema = yup.object().shape({
    presence: yup.boolean().required()
});

@withFormWrapper({
    validationSchema,
    mapPropsToValues: ({ item }) => ({
        ...item,
        presence: item.presence !== 2 ? item.presence !== 0 : undefined
    })
})
export default class TrainerMarkForm extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        formAction: PropTypes.object.isRequired,
        item: PropTypes.object
    }

    render() {
        const { handleSubmit, formAction: { meta }, item } = this.props;

        return (
            <Spin spinning={meta.pending} >
                <div className="panel-view">
                    <Field
                        name="presence"
                        component={RadioButtons}
                        options={options}
                        label={{ content: "education.trainer.presence" }}/>
                    <Field
                        name="mark"
                        component={Input}
                        label={{ content: "education.trainer.mark" }}/>
                    <DefinitionField translate="common.comment" text={item.comment} />
                    <Button type="blue" loading={meta.pending} onClick={handleSubmit}>
                        <Translate content="modal_settings.save" />
                    </Button>
                </div>
            </Spin>
        )
    }
}
